import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/apps/landing2-ui/layouts/default.vue").then(m => m.default || m)),
  "full-width": defineAsyncComponent(() => import("/app/apps/landing2-ui/layouts/full-width.vue").then(m => m.default || m)),
  my: defineAsyncComponent(() => import("/app/apps/landing2-ui/layouts/my.vue").then(m => m.default || m))
}